<template>
  <div class="about">
    <div class="about-top">
      <img src="@/assets/about/about.png" width="100%" alt="">
      <div class="content-select">
        <div class="select-items">
          <a :class="['item', 'bold', selected === 0 ? 'select' : '']" href="javascript:void(0)" @click='selected = 0'>企业介绍</a>
          <!-- <a :class="['item', 'bold', selected === 1 ? 'select' : '']" href="javascript:void(0)" @click='selected = 1'>工作机会</a> -->
          <a :class="['item', 'bold', selected === 2 ? 'select' : '']" href="javascript:void(0)" @click='selected = 2'>联系我们</a>
        </div>
        <div class='about-tab animate__animated animate__fadeIn' v-show="selected === 0 && $store.state.scrollTop > 500">
          <ul>
            <li :class="{selected: $store.state.scrollTop > 500 && $store.state.scrollTop < 850}" @click="toWhere('ref0')">企业介绍</li>
            <li :class="{selected: $store.state.scrollTop > 850 && $store.state.scrollTop < 1750}" @click="toWhere('ref1')">发展历程</li>
            <li :class="{selected: $store.state.scrollTop > 1750 && $store.state.scrollTop < 2650}" @click="toWhere('ref2')">企业规模</li>
            <li :class="{selected: $store.state.scrollTop > 2650 && $store.state.scrollTop < 3450}" @click="toWhere('ref3')">企业IP</li>
            <li :class="{selected: $store.state.scrollTop > 3450 && $store.state.scrollTop < 4100}" @click="toWhere('ref4')">未来趋势</li>
            <li :class="{selected: $store.state.scrollTop > 4100}" @click="toWhere('ref5')">企业文化</li>
          </ul>
        </div>
      </div>
    </div>
    <div ref="hash"></div>
    <!--关于我们-->
    <div class="animate__animated animate__fadeIn" v-show="selected == 0">
      <div class="about-content" ref="ref0">
        <div class="about-com-des">
          <h4 class="text-center com-title color-FF8C33">企业介绍</h4>
          <div class="com-en">
            <span></span>
            <i>ENTERPRISE INTRODUCTION</i>
            <span></span>
          </div>
          <p class="com-des-info">
            鋆尚科技成立于 2019 年，是一家专注于软件平台、硬件输出、 运营管理、社区商业的综合服务管理公司，以移动互联网、图像识别、传感等关键物联技术为媒介，致力于服务社区、推动业主自治，打造全方位闭环管理模式。
          </p>
          <p class="com-des-info">
            鋆尚科技本着“做对社会发展有意义的事情”的原则，坚持“普惠、利他、可持续发展”的经营理念，持续聚焦服务平台的打造， 聚焦科技研发、硬件输出管理，用人工智能为服务赋能，实现社区的自我治理，为业主提供更为自主性的生长空间。
          </p>
        </div>
      </div>
      <div class="about-content" ref="ref1">
        <div class="about-com-des">
          <h4 class="text-center com-title color-FF8C33">发展历程</h4>
          <div class="com-en">
            <span></span>
            <i>DEVELOPMENT HISTORY</i>
            <span></span>
          </div>
          <div class="about-history-img">
              <img src="@/assets/about/history-2.png" alt="">
              <img src="@/assets/about/about-history.png" alt="">
          </div>
        </div>
      </div>
      <div class="about-content zuzhi" ref="ref2">
        <div class="about-com-des">
          <h4 class="text-center com-title color-FF8C33">企业规模</h4>
          <div class="com-en">
            <span></span>
            <i>enterprise size</i>
            <span></span>
          </div>
        </div>
      </div>
      <img src="@/assets/about/zuzhi.png" style="width: 100%; margin: 0 auto" alt="">
      <div class="about-content about-ip" ref="ref3">
        <div class="about-com-des">
          <h4 class="text-center com-title color-FF8C33">企业IP</h4>
          <div class="com-en">
            <span></span>
            <i>ENTERPRISE INTRODUCTION</i>
            <span></span>
          </div>
          <p class="com-des-info">
            结合AI人工智能理念同时赋予爱多路以“爱”出发的初心力求通过“爱多多”传达爱多路科技、智能、以人为本的行业理念。
          </p>
          <div style="width: 80%; margin: 10rem auto 0;">
            <img src="@/assets/about/ip.png" alt="" width="100%">
          </div>
        </div>
      </div>
      <div class="about-content" ref="ref4">
        <div class="about-com-des">
          <h4 class="text-center com-title color-FF8C33">未来趋势</h4>
          <div class="com-en">
            <span></span>
            <i>FUTURE TRENDS</i>
            <span></span>
          </div>
          <div style="width: 100%; margin: 0 auto;">
            <div class="feture-list">
                <div class="feture-item" @click="choose=0">
                  <img v-if="choose==0" src="@/assets/about/parking-l.png" alt="">
                  <img v-if="choose!=0" src="@/assets/about/parking-d.png" alt="">
                  <span :style="{color: (choose===0 ? '#FF8C33' : '#434343'), fontSize: '1.4rem' }">车位共享</span>
                </div>
                <div class="feture-item" @click="choose=1">
                  <img v-if="choose==1" src="@/assets/about/user-l.png" alt="">
                  <img v-if="choose!=1" src="@/assets/about/user-d.png" alt="">
                  <span :style="{color: (choose===1 ? '#FF8C33' : '#434343'), fontSize: '1.4rem' }">人力共享</span>
                </div>
                <div class="feture-item" @click="choose=2">
                  <img v-if="choose==2" src="@/assets/about/ai-l.png" alt="">
                  <img v-if="choose!=2" src="@/assets/about/ai-d.png" alt="">
                  <span :style="{color: (choose===2 ? '#FF8C33' : '#434343'), fontSize: '1.4rem' }">智能公司</span>
                </div>
                <div class="feture-item" @click="choose=3">
                  <img v-if="choose==3" src="@/assets/about/data-l.png" alt="">
                  <img v-if="choose!=3" src="@/assets/about/data-d.png" alt="">
                  <span :style="{color: (choose===3 ? '#FF8C33' : '#434343'), fontSize: '1.4rem' }">大数据</span>
                </div>
                <div class="feture-item" @click="choose=4">
                  <img v-if="choose==4" src="@/assets/about/house-l.png" alt="">
                  <img v-if="choose!=4" src="@/assets/about/house-d.png" alt="">
                  <span :style="{color: (choose===4 ? '#FF8C33' : '#434343'), fontSize: '1.4rem' }">地产开发</span>
                </div>
            </div>
          </div>
        </div>
        <div class="feture-item-info" style="width: 100%; line-height:1.4rem; padding: 4.5rem 0; background: #f9f9f9; margin-bottom: 8rem;">
          <p class="text-center" v-if="choose===0">
            车位共享”即“错时停车共享车位”，把有限的资源最大化，将业主的闲置停车位作为一种存量资源，以共享方式焕发新生力。
          </p>
          <p class="text-center" v-if="choose===1">
            人力共享-建立健全的供应商人才库，未来实现个人管治社区，用系统管理人员。
          </p>
          <p class="text-center" v-if="choose===2">
            智能公司-围绕业主的衣食住行、生老病死，建立最为贴近、贴心、有预判能力的生态服务系统，将以预判引发供应来满足即将发生的需求，提供更加精细化、精准化、智能化的服务。            </p>
          <p class="text-center" v-if="choose===3">
            大数据-聚焦业主本身的大数据公司，可以精准分析业主的消费喜好、出行习惯、群体定位等
          </p>
          <p class="text-center" v-if="choose===4">
            地产开发-通过中台数据抓取，可以计算分析出一个区域的人群层次，住宅需求等，将分析结果提供给开发公司，设计出符合业主需求的房产
          </p>
        </div>
      </div>
      <div class="about-content" ref="ref5">
        <div class="about-com-des">
          <h4 class="text-center com-title color-FF8C33">企业文化</h4>
          <div class="com-en">
            <span></span>
            <i>CORPORATE CULTURE</i>
            <span></span>
          </div>
          <div style="width: 100%; margin: 0 auto;">
            <img src="@/assets/about/wenhua.png" alt="" width="100%">
          </div>
        </div>
      </div>
      <div class="slogan">
        <img src="@/assets/about/slogan.png" alt="">
      </div>
      <div style="margin-top: 14.6rem;">
        <img src="@/assets/about/foot.png" alt="" width="100%">
      </div>
    </div>
    <!--工作机会-->
    <div class="animate__animated animate__fadeIn" v-show="selected == 1">
      <div class="zuzhi">
        <div class="about-com-des">
          <h4 class="text-center com-title color-FF8C33">工作机会</h4>
          <div class="com-en">
            <span></span>
            <i>Job opportunities</i>
            <span></span>
          </div>
        </div>
        <div class="job">
          <ul class="job-head">
            <li>职位名称</li>
            <li>职位类别</li>
            <li>工作地点</li>
            <li>发布时间</li>
            <li>操作</li>
          </ul>
          <ul class="flex flex-r-between flex-c-center job-item" :class="getOne ? 'choosed' : ''" @click="getOne = !getOne">
            <li>城市总经理储备</li>
            <li>城市经理</li>
            <li>常州</li>
            <li>2020.5.30</li>
            <li class="arrow">
              <img v-show="getOne" src="@/assets/about/arrow-l.png" alt="">
              <img v-show="!getOne" src="@/assets/about/arrow-d.png" alt="">
            </li>
          </ul>
          <transition>
            <div v-if="getOne">
              <div class="flex job-item-des">
                <span>工作职责</span>
                <p style="text-align: left;">
                  1、具备一定的团队管理能力，负责区域内小区的日常管理工作；<br>
                  2、贯彻落实公司的经营方针，完成项目各项经营管理指标；<br>
                  3、负责外部关系的维护；<br>
                </p>
              </div>
              <div class="flex job-item-des">
                <span>任职要求</span>
                <p style="text-align: left;">
                  1、年龄28-35岁，本科及以上学历；能接受出差及调配；<br>
                  2、具有两年以上物业住宅小区管理经验，熟悉物业管理工作、物业行业政策
                  或其他行业三年以上管理经验；<br>
                  3、具有较强的经营管理能力，能独立带团队；
                  具有创新意识及接受新事物能力并能驱动变革。<br>
                </p>
              </div>
            </div>
          </transition>
          <ul class="flex flex-r-between flex-c-center job-item" :class="getTwo ? 'choosed' : ''" @click="getTwo = !getTwo">
            <li>管理培训生</li>
            <li>不等</li>
            <li>常州</li>
            <li>2020.5.30</li>
            <li class="arrow">
              <img v-show="getTwo" src="@/assets/about/arrow-l.png" alt="">
              <img v-show="!getTwo" src="@/assets/about/arrow-d.png" alt="">
            </li>
          </ul>
          <transition>
            <div v-if="getTwo">
              <div class="flex job-item-des">
                <span>工作职责</span>
                <p style="text-align: left;">
                  1、学习、培训
                </p>
              </div>
              <div class="flex job-item-des">
                <span>任职要求</span>
                <p style="text-align: left;">
                  1、较高的培养潜力/吃苦耐劳/认同物业行业发展/有较强客户服务意识/具有良好的沟通协调能力和团队意识
                </p>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <!--联系我们-->
    <div class="animate__animated animate__fadeIn" v-show="selected == 2">
      <div class="about-com-des">
        <h4 class="text-center com-title color-FF8C33">联系我们</h4>
        <div class="com-en">
          <span></span>
          <i>contact us</i>
          <span></span>
        </div>
      </div>
      <div class="flex flex-r-center flex-c-center contact-us">
        <div class="flex flex-c-center flex-r-center">
          <img src="@/assets/about/phone.png" alt="" style="width: 3.3rem; height: 4.2rem; margin-right: 1rem;">
          <span>联系电话：4000519886</span>
        </div>
        <div class="flex flex-c-center flex-r-center">
          <img src="@/assets/about/email.png" alt="" style="width: 3.8rem; height: 3rem; margin-right: 1rem;">
          <span>邮箱电话：hr@idoru.cn</span>
        </div>
        <div class="flex flex-c-center flex-r-center">
          <img src="@/assets/about/address.png" alt="" style="width: 3rem; height: 4.2rem; margin-right: 1rem;">
          <span>企业地址：江苏省常州市钟楼区大数据产业园1601</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from 'wowjs'
export default {
  name: 'About',
  components: {
  },
  data () {
    return {
      selected: 0,
      choose: 0,
      getOne: false,
      getTwo: false
    }
  },
  methods: {
    toWhere (where) {
      this.$refs[where].scrollIntoView({ behavior: 'smooth' })
    }
  },
  computed: {
    routeSelected () {
      return this.$route.query.selected
    }
  },
  watch: {
    routeSelected (val) {
      const t = this
      t.selected = val !== undefined ? parseInt(val) : 0
      setTimeout(() => {
        t.$refs.hash.scrollIntoView({
          behavior: 'smooth'
        })
      }, 100)
    }
  },
  mounted () {
    const t = this
    if (t.$route.query.selected !== undefined) {
      t.selected = parseInt(t.$route.query.selected)
      setTimeout(() => {
        t.$refs.hash.scrollIntoView({
          behavior: 'smooth'
        })
      }, 100)
    }
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animate__animated',
      offset: 0,
      mobile: true
    })
    wow.init()
  }
}
</script>
<style scoped>
.color-FF8C33 {
  color: #FF8C33 !important;
}
.bold {
  font-weight: bold;
}
.about {
  padding-top: 4.3rem;
}
.about-top {
  position: relative;
}
.content-select {
  width: 100%;
  height: 9.4rem;
  position: absolute;
  bottom: 0;
  left: 0;
  background: rgba(0,0,0,.2);
}
.select-items {
  width: 70%;
  height: 100%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.select-items .item {
  flex: 1;
  text-decoration: none;
  color: #FFFFFF;
  font-size: 2rem;
}
.select-items .item.select {
  display: block;
  color: #FF903A;
  font-size: 26rpx;
  position: relative;
}
.select-items .item.select:after {
  content: '';
  display: block;
  width: 6rem;
  height: 0;
  position: absolute;
  bottom: -1rem;
  left: 50%;
  margin-left: -3rem;
  border-radius: .2rem;
  border-top: .4rem solid #FF8C33;
}
.about-tab {
  position: fixed;
  z-index: 10;
  top: 14rem;
  left: 9rem;
}
.about-tab ul {
  background: #FFFFFF;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 0 20px 2px rgba(231,230,230, 0.6);
  padding: 2rem 2.5rem;
  box-sizing: border-box;
}
.about-tab li {
  font-size: 1.6rem;
  width: 9.2rem;
  line-height: 2rem;
  margin: 1.5rem 0;
  cursor: pointer;
  border-left: 0.3rem solid #ffffff;
}
.about-tab li.selected {
  border-color: #FF8C33;
  color: #FF8C33;
  font-weight: bolder;
}
.text-center {
  text-align: center;
}
.about-com-des {
  padding: 8rem 26.2rem;
  line-height: 1;
}
.zuzhi .about-com-des {
  padding: 8rem 26.2rem 2rem 26.2rem;
}
.about-com-des .com-title {
  font-size: 2.6rem;
  font-weight: bold;
  padding: 0;
  margin: 0;
}
.about-com-des .com-en {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2.4rem 0 6rem;
}
/* .zuzhi .about-com-des .com-en {
  padding: 2.4rem 0 0;
} */
.about-com-des .com-en span {
  width: 15rem;
  height: 0;
  border-top: 1px solid #CECECE;
}
.about-com-des .com-en i {
  padding: 0 2rem;
  font-style: normal;
  font-size: 2.6rem;
  font-weight: bold;
  color: #E7E6E6;
  text-transform: uppercase;
}
.about-com-des .com-des-info {
  width: 100%;
  margin: 0 auto;
  color: #434343;
  font-size: 1.4rem;
  line-height: 2.8rem;
}

.about-history-img {
  display: flex;
  justify-content: space-between;
  justify-items: center;
  width: 100%;
  margin: 0 auto;
}
.about-history-img img {
  display: block;
  object-fit: contain;
  width: 45%;
}
.feture-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
}
.feture-item-info {
  color: #999999;
  font-size: 1.4rem;
}
.feture-item img {
  width: 9rem;
}
.feture-item span {
  font-size: 1.4rem;
}
.zuzhi {
  width: 100%;
  margin: auto;
}
.zuzhi img {
  width: 100%;
}
.slogan {
  width: 100%;
  height: 12rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FFF9F4;
}
.slogan img {
  width: 40rem;
  margin-top: 2rem;
}

/* job */
.job {
  max-width: 150rem;
  margin: 0 auto;
  padding-bottom: 5rem;
}
ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
.job-head {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  height: 8rem;
  background: #FFF9F4;
  list-style: none;
}
li {
  width: 100%;
  font-style: normal;
  text-align: center;
}
.job-head li {
  font-size: 1.8rem;
}
.job-item {
  padding: 2rem 0;
  border-top: 1px solid #f8f8f8;
}
.job-head +.job-item {
  border-top: none;
}
.job-item li {
  font-size: 1.6rem;
}
.job-item.choosed li {
  color: #FF903A;
}
.job-item-des > span {
  width: 12.5%;
  box-sizing: border-box;
  padding-right: 1%;
  text-align: right;
  font-size: 1.5rem;
  padding-top: 3rem;
  line-height: 3rem;
  margin-right: 3rem;
  font-weight: bolder;
}
.job-item-des p {
  margin: 3rem 0;
  font-size: 1.4rem;
  line-height: 3rem;
}
.arrow img {
  width: 1.25rem;
  margin: auto;
}
.contact-us {
  padding-bottom: 17rem;
}
.contact-us > div:nth-of-type(2) {
  padding: 0 10rem 0;
}
.contact-us > div span {
  font-size: 1.6rem
}
.flex {
  display: flex;
}
.flex-r-between {
  justify-content: space-between;
}
.flex-r-center {
  justify-content: center;
}
.flex-c-center {
  align-items: center;
}
.v-enter, .v-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
.v-enter-active, .v-leave-active {
  transition: all 0.4s ease;
}
</style>
